export const topUpRoutes = [
  {
    path: "/top-up/choose-type",
    name: "TopUpChooseType",
    component: () => import("@/views/TopUp/ChooseType.vue"),
  },
  {
    path: "/top-up/choose-coin",
    name: "TopUpChooseCoin",
    component: () => import("@/views/TopUp/ChooseCoin.vue"),
  },
  {
    path: "/top-up/choose-network",
    name: "TopUpChooseNetwork",
    component: () => import("@/views/TopUp/ChooseNetwork.vue"),
  },
  {
    path: "/top-up/get-address",
    name: "TopUpGetAddress",
    component: () => import("@/views/TopUp/GetAddress.vue"),
  },
];
